import { authRefresh } from "./_auth-refresh";


export const authMiddleWare = async () => {
    const authExpiration = new Date(localStorage.getItem('auth-expiration'));
    if(authExpiration <= new Date()) {
        await authRefresh();
    }
}